import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";

export const getListAreaOnly = async (params = "") => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : "";

  return api({}, true).get(`/${PUBLIC_V1}/areas?_for=areaonly${newParams}`)
}

export const getListPropertyCategories = async (params = "") => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : "";

  return api({}, true).get(`/${PUBLIC_V1}/property-categories?${newParams}`)
}

export const getListPropertyType = async (params = "") => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : "";

  return api({}, true).get(`/${PUBLIC_V1}/property-types?${newParams}`)
}

export const getUnitPrice = async (params = "") => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : "";

  return api({}, true).get(`/${PUBLIC_V1}/unit-prices?${newParams}`)
}

export const getAllAreasComplete = async (params = {}) => {
  let allData = [];
  let page = 1;
  let hasMoreData = true;
  
  while (hasMoreData) {
    const newParams = { ...params, page, _limit: 1000 };
    const queryString = objectToQueryParams(newParams);
    
    const response = await api({}, true).get(`/${PUBLIC_V1}/areas?_for=areaonly&${queryString}`);
    
    if (response?.data?.data?.length > 0) {
      allData = [...allData, ...response.data.data];
      page++;
      
      // Check if we got less than the limit, meaning we've reached the end
      if (response.data.data.length < 30) {
        hasMoreData = false;
      }
    } else {
      hasMoreData = false;
    }
  }
  
  return {
    data: {
      data: allData,
      total: allData.length
    }
  };
}

export const getListPropertyCategoriesComplete = async (params = {}) => {
  let allData = [];
  let page = 1;
  let hasMoreData = true;
  
  while (hasMoreData) {
    const newParams = { ...params, page, _limit: 1000 };
    const queryString = objectToQueryParams(newParams);
    
    const response = await api({}, true).get(`/${PUBLIC_V1}/property-categories?${queryString}`);
    
    if (response?.data?.data?.length > 0) {
      allData = [...allData, ...response.data.data];
      page++;
      
      // Check if we got less than the limit, meaning we've reached the end
      if (response.data.data.length < 30) {
        hasMoreData = false;
      }
    } else {
      hasMoreData = false;
    }
  }
  
  return {
    data: {
      data: allData,
      total: allData.length
    }
  };
}

export const getCountryCodes = async (params = "") => {
  const newParams = (!!params && typeof params === "object") ? `&${objectToQueryParams(params)}` : "";

  return api({}, true).get(`/${PUBLIC_V1}/country_codes?${newParams}`)
}

export const postPropertyShare = async (slug, data) => {
  return api({}, true).post(`/${PUBLIC_V1}/properties/${slug}/property-shares`, data);
};

export const getListMarketing = async (params) => {
  const queryString = objectToQueryParams(params);
  return api({}, true).get(`/${PUBLIC_V1}/module/user/all?${queryString}`);
};